import _ from "lodash";
import "./EditAccountPage.css";
import {
  closeEditAccountNotification,
  detachAccountFromSystemByID,
  editAccount,
  getVisibleSystemsForAccountShort,
  updateAssignmentByID,
  closeDetachAccountNotification,
  clearEditAccountState,
  unregisterFromMobileApp,
  setAskedAccountId,
  getAccount,
  closeNotificationSettingsUpdate
} from "../../stores/actions/accountActions";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import BackArrow from "@material-ui/icons/ArrowBackSharp";
import Button from "@material-ui/core/Button";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InputAdornment from "@material-ui/core/InputAdornment";
import Loading from "../../components/Loading/Loading";
import MenuItem from "@material-ui/core/MenuItem";
import NotificationsSettings from "./NotificationsSettings";
import Person from "@material-ui/icons/Person";
import Phone from "@material-ui/icons/Phone";
import React from "react";
import Snackbar from "../../../components/Snackbar/Snackbar";
import TextField from "@material-ui/core/TextField";
import withStyles from "@material-ui/core/styles/withStyles";
import { getHeaderStyle, emptyHeaderStyle, loaderStyleEmptyCard } from "../../helpers/CustomStyles";
import utils from "../../helpers/GlobalVariables";
import UnbindUserFromSystem from "./UnbindUserFromSystem";
import RegisterInMobileApp from "./RegisterInMobileApp";
import UnregisterFromMobileApp from "./UnregisterFromMobileApp";
import SystemSearchBar from "./SystemSearchBar";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  withoutHelpTextStyle: {
    marginTop: "0",
    marginBottom: "30px",
  },
  // ...wiseneCustomSelectStyle,
  // ...customCheckboxRadioSwitch
};

class EditAccountPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessRightToAccount: "",
      updatedAt: "",
      language: "",
      languageState: "",
      timezone: "",
      timezoneState: "",
      name: "",
      nameState: "",
      password: "",
      passwordState: "",
      phone: "",
      phoneState: "",
      email: "",
      emailState: "",
      emailError: false,
      nameError: false,
      phoneError: false,
      emailExists: false,
      required: true,
      isUserDetachedFromSystem: false,
      firstRender: true,
      previousSystems: [],
      accountLoaded: false,
      invalidParam: true,
    };
    this.closeNotificationTimer = null;
    this.initialState = this.state;

    this.languages = [{ value: "en", label: "English", disabled: false }];

    this.timezones = ["Europe/Warsaw"];
  }

  componentWillMount() {
    this.props.clearEditAccountState();
  }

  componentDidMount() {

    const param = this.props.match?.params?.accountId;
    if (param) {
        const accountId = parseInt(param);
        if (accountId && !isNaN(accountId)) {
            this.setState({ invalidParam: false })
            this.props.getAccount(accountId);
        }
    }
    this.props.closeEditAccountNotification();
    this.props.closeDetachAccountNotification();
    this.props.closeNotificationSettingsUpdate();
  }

  handleIsUserDetachedFromSystem = () => {
    this.setState({ isUserDetachedFromSystem: true });
  };

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.accountLoaded && (this.props.account?.id === parseInt(this.props.match.params.accountId)) && this.props.account?.systemsDetails) {
        this.setState({ accountLoaded: true, previousSystems: this.props.account.systemsDetails });
        this.handleUpdateAccount();
    }
    const {accessRightToAccount, updatedAt, name, phone, email, language, timezone} = this.state;
    if (this.state.accountLoaded && (accessRightToAccount !== prevState.accessRightToAccount || updatedAt !== prevState.updatedAt || name !== prevState.name || phone !== prevState.phone || email !==prevState.email || language !== prevState.language ||  timezone !== prevState.timezone)) {
        this.handleUpdateAccount();
    }

    if (this.state.isUserDetachedFromSystem) {
      this.props.getVisibleSystemsForAccountShort(parseInt(this.props.match.params.accountId));
      this.setState({ isUserDetachedFromSystem: false });
    }

    if ((this.props.editAccountFail || this.props.editAccountSuccess || this.props.emailOrPhoneAlreadyTaken) && !this.closeNotificationTimer) {
      this.closeNotificationTimer = setTimeout(this.props.closeEditAccountNotification, 6000);
    }

    if (this.state.accountLoaded && (this.state.previousSystems !== this.props.account.systemsDetails)) {
      this.setState({ previousSystems: this.props.account.systemsDetails })
    }

    if ((this.props.notificationSettingsUpdatedFailed || this.props.notificationSettingsUpdatedSuccessfully)) {
      this.closeNotificationTimer = setTimeout(this.props.closeNotificationSettingsUpdate, 6000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.closeNotificationTimer);
  }

  handleUpdateAccount = () => {
    const { updatedAt } = this.state;
    const { account } = this.props;
    if (account !== undefined && account !== "" && updatedAt !== account.updatedAt) {
      this.setState({
        accessRightToAccount: account.accessRightToAccount.String,
        updatedAt: account.updatedAt,
        name: account.name,
        phone: account.phone.String,
        email: account.email,
        //TODO: delete overwriting different value than "en"
        language: account.language.Valid ? (account.language.String !== "en" ? "en" : account.language.String) : "en",
        timezone: account.timezone.Valid ? account.timezone.String : "Europe/Warsaw",
      });
    }
  };

  handleSimple = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  verifyEmail(email) {
    //RFC 2821 standard for email validation:
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return email.match(emailRegex);
  }

  verifyName(name) {
    return name.length > 2;
  }

  verifyLanguage(language) {
    const allowedLanguages = this.languages.map((l) => l.value);
    return _.indexOf(allowedLanguages, language) > -1;
  }

  verifyTimezone(timezone) {
    return _.indexOf(this.timezones, timezone) > -1;
  }

  verifyPhone(phone) {
    const phoneRex = /^\+\d{11,13}$/;
    return phone.match(phoneRex);
  }

  change(event, stateName, type) {
    switch (type) {
      case "email":
        //verify email with email pattern:
        if (this.verifyEmail(event.target.value)) {
          //check if input has incorrect character
          if (this.handleInputChange(event)) {
            this.setState({ [stateName + "Error"]: true });
          } else {
            this.setState({ [stateName + "Error"]: false });
          }
        } else {
          this.setState({ [stateName + "Error"]: true });
        }
        break;
      case "phone":
        // allow empty phone number for users without SMS notifications
        if (event.target.value === "") {
          this.setState({ [stateName + "Error"]: false });
          //verify phone with phone pattern
        } else if (this.verifyPhone(event.target.value)) {
          //check if input has incorrect sign:
          if (this.handleInputChange(event)) {
            this.setState({ [stateName + "Error"]: true });
          } else {
            this.setState({ [stateName + "Error"]: false });
          }
        } else {
          this.setState({ [stateName + "Error"]: true });
        }
        break;
      case "name":
        //verify name with name pattern
        if (this.verifyName(event.target.value)) {
          //check if input has incorrect character
          if (this.handleInputChange(event)) {
            this.setState({ [stateName + "Error"]: true });
          } else {
            this.setState({ [stateName + "Error"]: false });
          }
        } else {
          this.setState({ [stateName + "Error"]: true });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }

  handleEditAccount = () => {
    let accountData = {
      email: this.state.email,
      accountID: this.props.account.id,
      language: this.state.language,
      name: this.state.name,
      phone: this.state.phone,
      timezone: this.state.timezone,
      updatedAt: this.state.updatedAt.Time.slice(0, -1).replace("T", " "),
    };
    this.props.editAccount(accountData, this.props.loggedUserId);
  };

  checkInvalidCharacters = (str) => {
    const invalidCharacters = [
      "<",
      ">",
      "&lt;",
      "&gt;",
      "&#60;",
      "&#62;",
      "/",
      "&#47;",
      "\\",
      "&#92;",
      "&",
      "&amp;",
      "&#38;",
      ";",
    ];
    const containesChar = (char) => str.includes(char);
    const isIncorrectValue = invalidCharacters.some(containesChar);
    if (isIncorrectValue) {
      return true;
    }
    if (!str) {
      return true;
    }
    return false;
  };

  handleInputChange = (e) => {
    const inputValue = e.target.value;
    this.checkInvalidCharacters(inputValue);
  };

  renderMobileNotificationsAccount = () => {
    const { editAccountFail, editAccountSuccess, emailOrPhoneAlreadyTaken, notificationSettingsUpdatedFailed, notificationSettingsUpdatedSuccessfully, mobileView } = this.props;
    const error = editAccountFail || emailOrPhoneAlreadyTaken;
    const headerStyle = getHeaderStyle(error);

    if (mobileView) {
      if (editAccountFail || emailOrPhoneAlreadyTaken || editAccountSuccess) {
        return (
          <h5
            className={
              editAccountSuccess ? "notification-open-edit-account-success" : "notification-open-edit-account-fail"
            }
            style={headerStyle}
          >
            {emailOrPhoneAlreadyTaken
              ? "Email or phone already taken"
              : editAccountFail
                ? "Edit account failed"
                : "Account data were saved successfully"}
          </h5>
        );
      }
      return <div style={emptyHeaderStyle}></div>;
    }
  };

  renderMobileNotificationsNotifications = () => {
    const { notificationSettingsUpdatedFailed, notificationSettingsUpdatedSuccessfully, mobileView } = this.props;
    const headerStyle = getHeaderStyle(notificationSettingsUpdatedFailed);

    if (mobileView) {
      if (notificationSettingsUpdatedFailed || notificationSettingsUpdatedSuccessfully) {
        return (
          <h5
            className={
              notificationSettingsUpdatedSuccessfully ? "notification-open-edit-account-success" : "notification-open-edit-account-fail"
            }
            style={headerStyle}
          >
            {notificationSettingsUpdatedFailed
                ? "Edit notifications failed"
                : "Notifications were saved successfully"}
          </h5>
        );
      }
      return <div style={emptyHeaderStyle}></div>;
    }
  };

  renderSystemSearchBar = () => {
    const { previousSystems } = this.state;
    if (!previousSystems || !previousSystems.length) return null;
    return <SystemSearchBar
      systems={previousSystems}
    />
  }
  render() {
    const { accessRightToAccount, name } = this.state;
    const {
      classes,
      closeEditAccountNotification,
      notificationSettingsUpdatedSuccessfully,
      notificationSettingsUpdatedFailed,
      closeNotificationSettingsUpdate,
      editAccountFail,
      editAccountSuccess,
      emailOrPhoneAlreadyTaken,
      mobileView,
      account
    } = this.props;
    if (!this.state.accountLoaded) {
      return (
        <GridContainer>
          <GridItem xs={12} style={{ padding: "30px" }}>
            <Card>
              <CardBody>
               { this.props.forbidden || this.state.invalidParam ?
               <div  style={{ padding: "10px", ...loaderStyleEmptyCard }}>403</div>
               :
                <div style={{ padding: "10px", ...loaderStyleEmptyCard }}>
                  <Loading transform={0.85} height={90} width={70} color="gray" />
                </div>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    }
    const systems = account?.systemsDetails;
    const backLink =
      this.props.location.state &&
      this.props.location.state.from &&
      this.props.location.state.from.startsWith("/accounts")
        ? this.props.location.state.from
        : "/accounts";
    return (
      <div>
        <NavLink to={backLink}>
          <Button size="small" className="goToAccounts">
            <BackArrow /> Accounts
          </Button>
        </NavLink>
        <Card className="editAccountPage">
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <Person className={classes.person} />
            </CardIcon>
            <h4 className={classes.cardIconTitle} style={{ color: "#3C4858" }}>
              Account Details
            </h4>
          </CardHeader>
          <CardBody>{this.renderForm()}</CardBody>
          {!mobileView ? (
            <Snackbar
              close
              closeNotification={() => closeEditAccountNotification()}
              color={!editAccountSuccess ? "danger" : "success"}
              message={
                editAccountFail
                  ? "Edit account failed"
                  : emailOrPhoneAlreadyTaken
                    ? "Email or phone already taken"
                    : "Account data were saved successfully"
              }
              open={editAccountFail || emailOrPhoneAlreadyTaken || editAccountSuccess}
              place="tc"
              key={
                editAccountFail
                  ? "edit-account-failed"
                  : emailOrPhoneAlreadyTaken
                    ? "edit-account-duplicate-data"
                    : "edit-account-success"
              }
            />
          ) : null}
          {!mobileView ? (
            <Snackbar
              close
              closeNotification={() => closeNotificationSettingsUpdate()}
              color={notificationSettingsUpdatedFailed ? "danger" : "success"}
              message={
                notificationSettingsUpdatedFailed
                  ? "Edit notifications failed"
                  : "Notifications were saved successfully"
              }
              open={notificationSettingsUpdatedFailed || notificationSettingsUpdatedSuccessfully}
              place="tc"
              key={
                notificationSettingsUpdatedFailed
                  ? "edit-account-notifs-failed"
                  : "edit-account-notifs-success"
              }
            />
          ) : null}
        </Card>

        <GridContainer>
          <UnbindUserFromSystem
            userName={account.name}
            accountID={account.id}
            visibleSystems={_.filter([...systems], function (s) { return ['full', 'partial'].includes(s.accessRightsToAccount)})}
            lastSystem={systems?.length ?systems[0].lastSystem : false}
            handleIsUserDetachedFromSystem={this.handleIsUserDetachedFromSystem}
          />
          {account.QRCode ?
            account.RegisteredInMobileApp ?
            <UnregisterFromMobileApp
              accountID={account.id}
              unregisterFromMobileApp={this.props.unregisterFromMobileApp}
            />
          :
          <RegisterInMobileApp
            accountQRCode={account.QRCode}
          />
          : <></>
          }
        </GridContainer>

        <GridContainer>
          {this.renderSystemSearchBar()}
          {this.renderNotificationsSettings(this.state.previousSystems, accessRightToAccount)}
        </GridContainer>
      </div>
    );
  }

  renderNotificationsSettings(systems = [], accessRightToAccount) {
    if (!this.props.wasFetchedVisibleSystems && this.state.firstRender) {
      return (
        <GridContainer>
          <GridItem xs={12} style={{ padding: "30px" }}>
            <Card>
              <CardBody>
                <div style={{ padding: "10px", ...loaderStyleEmptyCard }}>
                  <Loading transform={0.85} height={90} width={70} color="gray" />
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    } else {
      return systems.map((system) => {
        const filteredSystem = this.props.accountFilteredSystemsNames.find(filteredSystem => filteredSystem === system.name)
        if (!filteredSystem && this.props.accountFilteredSystemsNames?.length) return null;
        const email = [];
        const push = [];
        const sms = [];
        //iterate through each key-value of each system
        for (const key in system) {
          //search for all email notifications:
          if (key.match("emailNotifications")) {
            //check if some match value is true:
            if (system[key]) {
              //cut emailNotification prefix:
              const currentValue = key.substr(18, key.length);
              //push one of following values as String: L1, L2, L3, L4, System, Heartbeat, Obstruction
              email.push(currentValue);
            }
          }
          //search for all push notifications:
          else if (key.match("pushNotifications")) {
            //check if some match value is true:
            if (system[key]) {
              //cut pushNotification prefix:
              const currentValue = key.substr(17, key.length);
              //push one of following values as String: L1, L2, L3, L4, System, Heartbeat, Obstruction
              push.push(currentValue);
            }
          }

          //search for all sms notifications:
          else if (key.match("smsNotifications")) {
            //check if some match value is true:
            if (system[key]) {
              //cut pushNotification prefix:
              const currentValue = key.substr(16, key.length);
              //push one of following values as String: L1, L2, L3, L4, System, Heartbeat, Obstruction
              sms.push(currentValue);
            }
          }
        }
        return (
          <NotificationsSettings
            account={this.props.account}
            accountRole={system.accountRole}
            accountName={this.state.name}
            editEnabled={accessRightToAccount === "full" || accessRightToAccount === "partial"}
            notificationsUpdated={this.props.notificationSettingsUpdatedFailed || this.props.notificationSettingsUpdatedSuccessfully}
            emailProps={email}
            pushProps={push}
            smsProps={sms}
            systemID={system.ID}
            systemName={system.name}
            updateAssignmentByID={this.props.updateAssignmentByID}
            assignmentUpdatedAt={system.AssignmentUpdatedAt}
            key={`Notification-settings-system-id-${system.ID}`}
            mobileView={this.props.mobileView}
            wasFetchedVisibleSystems={this.props.wasFetchedVisibleSystems}
            askedAccountId={parseInt(this.props.match.params.accountId)}
            getVisibleSystemsForAccountShort={this.props.getVisibleSystemsForAccountShort}
            systemVersion={system.systemVersion}
            renderMobileNotificationsNotifications={this.renderMobileNotificationsNotifications}
          />
        );
      });
    }
  }

  renderForm() {
    const { emailError, nameError, phoneError, accessRightToAccount } = this.state;
    const { disableEditAccountButton, classes, editAccountSuccess, editAccountFail } = this.props;
    const noneAccess = accessRightToAccount === "none" ? true : false;
    const readOnlyAccess = accessRightToAccount === "read_only" ? true : false;
    const minimalAccess = accessRightToAccount === "minimal" ? true : false;
    const partialAccess = accessRightToAccount === "partial" ? true : false;
    return (
      <GridContainer alignItems="center" justify="center">
        {noneAccess ? (
          <h3 className={classes.cardTitle}>You do not have access to edit this account.</h3>
        ) : (
          <>
            {this.renderEmail(readOnlyAccess, minimalAccess, partialAccess)}
            {this.renderLanguage(readOnlyAccess, minimalAccess, partialAccess)}
            {this.renderTimezone(readOnlyAccess, minimalAccess, partialAccess)}
            {this.renderFullName(readOnlyAccess, minimalAccess, partialAccess)}
            {this.renderPhone(readOnlyAccess, minimalAccess, partialAccess)}
            <GridItem xs={12}>
              {this.renderMobileNotificationsAccount()}
              {disableEditAccountButton ? (
                <div style={{ marginBottom: "10px", paddingLeft: "10px", paddingTop: "5px" }}>
                  <Loading transform={1} height={17} width={40} color="darkGray" />
                </div>
              ) : (
                <Button
                  block="true"
                  id="saveEditedDataButton"
                  onClick={this.handleEditAccount}
                  simple="true"
                  size="medium"
                  style={{ transition: "0.3s" }}
                  disabled={
                    emailError ||
                    nameError ||
                    phoneError ||
                    disableEditAccountButton ||
                    accessRightToAccount === "read_only" ||
                    accessRightToAccount === "none" ||
                    editAccountSuccess ||
                    editAccountFail
                  }
                >
                  Save
                </Button>
              )}
            </GridItem>
          </>
        )}
      </GridContainer>
    );
  }

  inputDisabled() {
    return this.state.accessRightToAccount === "full" ? false : true;
  }

  renderEmail(readOnlyAccess, minimalAccess, partialAccess) {
    const { classes } = this.props;
    const { email, emailError } = this.state;
    const gridStyle = { marginBottom: emailError ? "10px" : "30px" };
    return (
      <GridItem xs={12} md={6} style={gridStyle}>
        <TextField
          error={emailError}
          label="Email"
          helperText={emailError ? "Incorrect email" : ""}
          id="email"
          fullWidth
          style={{ opacity: readOnlyAccess || minimalAccess || partialAccess ? "0.5" : "1.0" }}
          inputProps={{ maxLength: utils.defaultMaxEmailLength, autoCapitalize: "off" }}
          InputProps={{
            readOnly: readOnlyAccess || minimalAccess || partialAccess,
            value: email,
            onChange: (event) => this.change(event, "email", "email"),
            endAdornment: (
              <InputAdornment position="end" className={classes.inputAdornment}>
                <Email className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
    );
  }

  renderTimezone(readOnlyAccess, minimalAccess, partialAccess) {
    const { classes } = this.props;
    const { timezone } = this.state;
    let menuItems = this.timezones.map((timezone, i) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value={timezone}
          key={`timezone-item-${i}`}
        >
          {timezone}
        </MenuItem>
      );
    });
    return (
      <GridItem xs={12} md={3} style={style.withoutHelpTextStyle}>
        <TextField
          select
          label="Choose timezone"
          // disabled={readOnlyAccess || minimalAccess}
          classes={{ select: classes.select }}
          value={timezone}
          onChange={this.handleSimple}
          fullWidth
          style={{ opacity: readOnlyAccess || minimalAccess ? "0.5" : "1.0" }}
          inputProps={{
            readOnly: readOnlyAccess || minimalAccess,
            name: "timezone",
            id: "select-timezone",
            autoCapitalize: "off",
          }}
        >
          {menuItems}
        </TextField>
      </GridItem>
    );
  }

  renderLanguage(readOnlyAccess, minimalAccess, partialAccess) {
    const { classes } = this.props;
    const { language } = this.state;
    let menuItems = this.languages.map((language, i) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value={language.value}
          key={`language-item-${i}`}
        >
          {language.label}
        </MenuItem>
      );
    });
    return (
      <GridItem xs={12} md={3} style={style.withoutHelpTextStyle}>
        <TextField
          select
          label="Choose language"
          classes={{ select: classes.select }}
          value={language}
          onChange={this.handleSimple}
          fullWidth
          style={{ opacity: readOnlyAccess ? "0.5" : "1.0" }}
          inputProps={{
            readOnly: readOnlyAccess,
            name: "language",
            id: "select-language",
            autoCapitalize: "off",
          }}
        >
          {menuItems}
        </TextField>
      </GridItem>
    );
  }

  renderFullName(readOnlyAccess, minimalAccess, partialAccess) {
    const { classes } = this.props;
    const { name, nameError } = this.state;
    const gridStyle = { marginBottom: nameError ? "10px" : "30px" };
    return (
      <GridItem xs={12} md={6} style={gridStyle}>
        <TextField
          error={nameError}
          label="Full name"
          helperText={nameError ? "Incorrect name" : ""}
          id="name"
          fullWidth
          value={name}
          onChange={(event) => this.change(event, "name", "name")}
          required
          style={{ opacity: readOnlyAccess || minimalAccess || partialAccess ? "0.5" : "1.0" }}
          inputProps={{ maxLength: utils.defaultMaxInputLength, autoCapitalize: "off" }}
          InputProps={{
            readOnly: readOnlyAccess || minimalAccess || partialAccess,
            endAdornment: (
              <InputAdornment position="end" className={classes.inputAdornment}>
                <Person className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
    );
  }

  renderPhone(readOnlyAccess, minimalAccess, partialAccess) {
    const { classes } = this.props;
    const { phone, phoneError } = this.state;
    const gridStyle = { marginBottom: phoneError ? "10px" : "30px" };
    return (
      <GridItem xs={12} md={6} style={gridStyle}>
        <TextField
          error={phoneError}
          label="Phone"
          helperText={phoneError ? "Incorrect phone number" : ""}
          id="phone"
          fullWidth
          onChange={(event) => this.change(event, "phone", "phone")}
          value={phone}
          style={{ opacity: readOnlyAccess || minimalAccess || partialAccess ? "0.5" : "1.0" }}
          inputProps={{ maxLength: utils.defaultMaxInputLength, autoCapitalize: "off" }}
          InputProps={{
            readOnly: readOnlyAccess || minimalAccess || partialAccess,
            endAdornment: (
              <InputAdornment position="end" className={classes.inputAdornment}>
                <Phone className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    account: state.account.account,
    forbidden: state.account.forbidden,
    emailState: state.account.emailState,
    nameState: state.account.nameState,
    phoneState: state.account.phoneState,
    languageState: state.account.languageState,
    editAccountSuccess: state.account.editAccountSuccess,
    editAccountFail: state.account.editAccountFail,
    disableEditAccountButton: state.account.disableEditAccountButton,
    emailExists: state.account.emailExists,
    loggedUserId: state.login.loggedUserId,
    emailOrPhoneAlreadyTaken: state.account.emailOrPhoneAlreadyTaken,
    mobileView: state.dashboard.mobileView,
    wasFetchedVisibleSystems: state.account.wasFetchedVisibleSystems,
    detachConfirmed: state.account.detachConfirmed,
    unregisterFromMobileAppConfirmed: state.account.unregisterFromMobileAppConfirmed,
    accountFilteredSystemsNames: state.account.accountFilteredSystemsNames,
    notificationSettingsUpdatedSuccessfully: state.dashboard.notificationSettingsUpdatedSuccessfully,
		notificationSettingsUpdatedFailed: state.dashboard.notificationSettingsUpdatedFailed,
		updatedSystemNotificationId: state.dashboard.updatedSystemNotificationId,
  };
};
const actions = {
  closeEditAccountNotification,
  detachAccountFromSystemByID,
  editAccount,
  getVisibleSystemsForAccountShort,
  updateAssignmentByID,
  closeDetachAccountNotification,
  setAskedAccountId,
  getAccount,
  clearEditAccountState,
  unregisterFromMobileApp,
  closeNotificationSettingsUpdate
};

export default connect(mapStateToProps, actions)(withRouter(withStyles(style)(EditAccountPage)));
